import { EntityType } from "@mapmycustomers/shared/enum";

import activityFieldModel from "./ActivityFieldModel";
import companyFieldModel from "./CompanyFieldModel";
import dealFieldModel from "./DealFieldModel";
import distanceFieldModel from "./DistanceFieldModel";
import entityHistoryFieldModel from "./entityHistoryFieldModel";
import integrationFieldModel from "./IntegrationFieldModel";
import leaderboardFieldModel from "./LeaderboardFieldModel";
import personFieldModel from "./PersonFieldModel";
import routeFieldModel from "./RouteFieldModel";
import tripFieldModel from "./tripFieldModel";
import universalFieldsFieldModel from "./universalFieldsFieldModel";

const entityTypeToFieldModel = {
  [EntityType.ACTIVITY]: activityFieldModel,
  [EntityType.COMPANY]: companyFieldModel,
  [EntityType.COMPANY_ROUTE]: routeFieldModel,
  [EntityType.DEAL]: dealFieldModel,
  [EntityType.DISTANCE]: distanceFieldModel,
  [EntityType.HISTORY]: entityHistoryFieldModel,
  [EntityType.INTEGRATION]: integrationFieldModel,
  [EntityType.LEADERBOARD]: leaderboardFieldModel,
  [EntityType.PEOPLE_ROUTE]: routeFieldModel,
  [EntityType.PERSON]: personFieldModel,
  [EntityType.ROUTE]: routeFieldModel,
  [EntityType.TRIP]: tripFieldModel,
  universal: universalFieldsFieldModel,
} as const;

export type EntityTypeWithFieldModel = keyof typeof entityTypeToFieldModel;
export type CanonicalEntityTypeWithFieldModel = Exclude<EntityTypeWithFieldModel, "universal">;

const getFieldModelByEntityType = (entityType: EntityTypeWithFieldModel) =>
  entityTypeToFieldModel[entityType];

export default getFieldModelByEntityType;
